module.exports = ".nospace{padding-left: 0px;}\r\n.nospace .box-title{vertical-align: -webkit-baseline-middle;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/home-pictures/home-pictures.component.css
// module id = ./src/app/modules/dashboard/home-pictures/home-pictures.component.css
// module chunks = dashboard.module